module.exports = __webpack_public_path__ + "static/media/misc-npc-garden-gnome.8fb64c67.png";